var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCloseWhite = function SvgCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70.071,
    height: 70.071,
    viewBox: "0 0 70.071 70.071"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.536 3.536l31.5 31.5m31.5 31.5l-31.5-31.5m0 0l31.5-31.5-63 63",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })));
};
export default SvgCloseWhite;